/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AccountsSettingsComponent } from './accounts-settings.component';
import { AuthGuard } from '../../../../../core/guards';
import { CentraliseManagementSharedModule } from '../../../shared/centraliseManagement.shared.module';
import { LoadbalancerSharedModule } from '../../../../loadbalancer/shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

/**
 *
 */
@NgModule({
    imports: [
        CentraliseManagementSharedModule,
        RouterModule,
        LoadbalancerSharedModule,
    ],
    declarations: [
        AccountsSettingsComponent
    ],
    providers: [
        AuthGuard
    ]
})

export class AccountsSettingsModule {
}
